import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getSupabaseConfigError, isSupabaseConfigured, supabase } from '../lib/supabase';
import BrandLogo from '../components/BrandLogo';

function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (event) => {
    event.preventDefault();
    setError('');

    const configError = getSupabaseConfigError();
    if (configError || !isSupabaseConfigured || !supabase) {
      setError(configError);
      return;
    }

    if (!email.trim() || !password) {
      setError('Enter admin email and password.');
      return;
    }

    setLoading(true);
    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: email.trim(),
      password,
    });
    setLoading(false);

    if (signInError) {
      setError(signInError.message || 'Login failed. Check your credentials.');
      return;
    }

    navigate('/admin', { replace: true });
  };

  return (
    <div className="admin-login">
      <form className="admin-login__card" onSubmit={onSubmit}>
        <div className="admin-login__brand">
          <BrandLogo size="sm" />
          <div>
            <strong>Saarthi Admin</strong>
            <p>Sign in to manage drivers and trips</p>
          </div>
        </div>

        <label className="field">
          <span>Email</span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
            placeholder="admin@example.com"
          />
        </label>

        <label className="field">
          <span>Password</span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            placeholder="••••••••"
          />
        </label>

        {error && <div className="form-alert form-alert--error">{error}</div>}

        <button type="submit" className="btn btn--primary btn--block" disabled={loading}>
          {loading ? 'Signing in…' : 'Sign in'}
        </button>

        <Link to="/" className="admin-login__back">
          ← Back to website
        </Link>
      </form>
    </div>
  );
}

export default AdminLogin;
